/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     角色 API 接口
  +--------------------------------------------------------------------------------------
*/
import request from "@/utils/request";

export function getAllRole(params) {
  return request({
    url: "?c=sys&a=role&do=getall",
    method: "get",
    params
  });
}

export function delRoleApi(formData) {
  return request({
    url: "?c=sys&a=role&do=delete",
    method: "post",
    data: formData
  });
}

export function getRoleDetailApi(params) {
  return request({
    url: "?c=sys&a=role&do=get",
    method: "get",
    params
  });
}

export function createRoleApi(formData) {
  return request({
    url: "?c=sys&a=role&do=create",
    method: "post",
    data: formData
  });
}

export function editRoleApi(formData) {
  return request({
    url: "?c=sys&a=role&do=edit",
    method: "post",
    data: formData
  });
}
